import { setFeatures } from "../state/modules/featureToggles/actions";
import sdkProvider from "./sdkProvider";

const setupFeatures = async ({ dispatch }) => {
  const sdk = await sdkProvider("features");
  await sdk.wait();
  dispatch(setFeatures(sdk.getFeaturesState()));
};

export default setupFeatures;
